import { Redirect, router } from 'expo-router';
import React, { useCallback, useEffect, useState } from 'react';
import { FullScreenSpinner, SafeAreaView, useToastController } from 'smoothie';

import useGetAllBankAccountDetails from '../../hooks/useGetAllBankAccountDetails';
import type { BankAccountDisplayDetail } from '../../types/BankAccount';
import { CardForm, CardStatus } from '../../types/Card';

const ActivateCardLanding = () => {
    const toast = useToastController();
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const { isLoading, errorFetching, bankAccountDetails } =
        useGetAllBankAccountDetails();

    const findUnactivatedPhysicalCard = useCallback(
        (accounts: BankAccountDisplayDetail[]) => {
            for (const account of accounts) {
                const card = (account.cards ?? []).find(
                    (card) =>
                        card.cardStatus === CardStatus.UNACTIVATED &&
                        card.form === CardForm.PHYSICAL,
                );
                if (card) {
                    return { account, card };
                }
            }
            return null;
        },
        [],
    );

    useEffect(() => {
        if (errorFetching) {
            toast.show('Something went wrong!');
            setShouldRedirect(true);
            return;
        }

        if (isLoading) return;

        const result = findUnactivatedPhysicalCard(bankAccountDetails);

        if (result) {
            const { account, card } = result;
            router.replace({
                pathname: '/banking/card/manage-card',
                params: {
                    syncteraAccountId: account.syncteraAccountId,
                    cardId: card.id,
                },
            });
        } else {
            toast.show('Could not find any physical cards to activate');
            setShouldRedirect(true);
        }
    }, [
        isLoading,
        errorFetching,
        bankAccountDetails,
        findUnactivatedPhysicalCard,
        toast,
    ]);

    if (shouldRedirect) {
        return <Redirect href="/home/banking" />;
    }

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <FullScreenSpinner />
        </SafeAreaView>
    );
};

export default ActivateCardLanding;
